<script setup lang="ts">
import { WidgetQuiz } from '~/components/widget/quiz'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetTrendingNews } from '~/components/widget/trending-news'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import type { IQuiz } from '~/components/widget/quiz'
import { useSeoFromCustom } from '~/composables/useSeoFromCustom'

const { locale } = useI18n()
const route = useRoute()
const quizId = Number(route.params.id)

const { data } = await useApi<{ data: IQuiz }>(`/quizzes/${quizId}`)
const quiz = computed(() => data.value?.data ?? null)

if (!quiz.value) showError({ statusCode: 404 })

useSeoFromCustom(
  computed(() => quiz.value ?? undefined),
  undefined,
  locale.value
)

const breadcrumbs = computed(() => [{ title: quiz.value?.title ?? '', url: route.path }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetTrendingNews />
            <WidgetCustomerCare />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <WidgetQuiz v-if="quiz" :quiz="quiz" />
      </ContentLayout>
    </Container>
  </Main>
</template>
